<template>
<div class="content">
    <toolbar v-bind:selection="toolbar" title="Editar colmenar" />

    <v-form ref="form" v-model="valid" lazy-validation>
                        <!--form v-on:submit.prevent="submitForm"-->
        <v-text-field
                v-model="infoform.name"
                color="orange"
                label="Nombre del colmenar*"
                :rules="nameRules"
        ></v-text-field>

        <v-text-field
                v-model="infoform.localization"
                color="orange"
                label="Localización"

        ></v-text-field>

        <!--v-file-input
                v-model="FILE"
                truncate-length="15"
                color="orange"
                label="Imagen del colmenar"
                prepend-icon="mdi-camera"
        ></v-file-input-->

        <!--input type="file" @change="onFileUpload"-->

        <p><b>Descripción</b></p>
        <v-col class="col" cols="12" md="6">
            <v-textarea
                    class="nonebold"
                    solo
                    id="description"
                    name="description"
                    label="Información adicional"
                    v-model="infoform.description"
                    @change="onFileUpload"
            ></v-textarea>
        </v-col>

        <loading v-bind:isloading="isloading" ></loading>

        <v-alert
                dense
                v-bind:type="alertForm"
                text
                :value="alert"
                transition="scale-transition"
        >
            {{responseform}}
        </v-alert>

        <v-btn :disabled="!valid" class="mr-4 btn-yellow" @click="validate">
            Aceptar
        </v-btn>



    </v-form>


</div>

</template>

<script>
import auth from "@/libs/auth"


import toolbar from "@/components/Toolbar"
import loading from "@/components/Loader"
import axios from "axios";

export default {
    name: 'editar-colmenar',
    components: {loading,toolbar},
    data() {
        return {

            toolbar: {
              return: '0',
            },

            valid: true,

            nameRules: [
                v => !!v || 'Requerido',
                v => (v && v.length <= 25) || 'Debe ser inferior a 25 caracteres',
            ],

          isloading:'',

        /* mensaje resultado form */
            alertForm:'success',
            responseform:'',
            alert: false,

            infoColmenar: null,
            infoform: {
                name: '',
                localization: '',
                image: '',
                description: ''
            }
        }
    },

    methods:{
      /*   onFileUpload (event) {
          this.infoform.image = event.target.files[0]

        },
        */
        validate () {
            this.$refs.form.validate()
            if(this.$refs.form.validate()){
                this.alert = false
                this.isloading = true
                axios.put('https://appws.panimiel.com/new/index.php/api/colmenar/'+this.$route.params.id, this.infoform)
                     .then((response) => {
                     this.responseform = response.data
                     this.alertForm = 'success'
                     this.isloading=''
                     this.alert = true
                })
                .catch((error) => {
                    this.alertForm = 'error',
                    this.isloading=''

                    if (error.response.status != 500){
                        this.responseform = error.response.data
                    }else{
                        this.responseform = 'Error, no ha sido posible editar el colmenar.'
                    }
                     this.alert = true

                 })
             }
        }
    },

    created() {

        auth.getUserLogged()

        var that = this
        axios.get("https://appws.panimiel.com/new/index.php/api/colmenar/"+this.$route.params.id).then((infoColmenar) => {
          that.infoColmenar = infoColmenar.data
            this.infoform.name = that.infoColmenar.name
            this.infoform.localization = that.infoColmenar.localization
            this.infoform.description = that.infoColmenar.description

        })
    }


}

</script>

<style scoped lang="scss">
</style>